import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'home',
  path: ({ courseSlug }: { courseSlug: string }) => `/courses/${courseSlug}`,
}

export default ROUTE
